var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Logo',{attrs:{"image-url":_vm.tenantLogoUrl,"description":_vm.tenantName}})
}
var staticRenderFns = []

export { render, staticRenderFns }